import GoalFormTour from './GoalFormTour';

export default GoalFormTour;
